import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompPhoneInputWrapperCore } from '../core/phone-input/wrapper'
import { CompPhoneInput } from './CompPhoneInput'

function CompPhoneInputWrapper() {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useCompBackgroundColor()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // form
  const formContext = useCompFormContext()

  return (
    <CompPhoneInputWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompPhoneInput {...props} />}
    </CompPhoneInputWrapperCore>
  )
}

export default CompPhoneInputWrapper
